<div class="flex justify-between content-center">
  <h3
    mat-dialog-title
    class="primary-color"
    data-test-id="select-availability-dialog-title"
  >
    Accept expert
  </h3>
  <button
    mat-icon-button
    mat-dialog-close
    data-test-id="select-availability-dialog-close-button"
  >
    <mat-icon>clear</mat-icon>
  </button>
</div>

<mat-dialog-content class="flex flex-col">
  <p data-test-id="select-availability-dialog-body">
    @if (data.readyToAccept.isReady) {
      <span>
        Accept expert for
        {{ data.availability | availabilityDate: data.timezone }}
        {{ data.availability | availabilityTime: data.timezone }}?
      </span>
    } @else {
      <span>
        {{ errorMessage }}
      </span>
    }
  </p>
  @if (data.readyToAccept.isReady && data.overlappingCalls.length) {
    <app-interview-period-call-overlap-warning
      [calls]="data.overlappingCalls"
      [timezoneName]="data.timezone"
    />
  }
</mat-dialog-content>

<mat-dialog-actions class="flex gap-2">
  <button
    mat-stroked-button
    color="primary"
    mat-dialog-close
    class="flex-1"
    data-test-id="select-availability-dialog-cancel-button"
  >
    Cancel
  </button>
  @if (data.readyToAccept.isReady) {
    <button
      mat-flat-button
      color="primary"
      class="flex-1"
      data-test-id="select-availability-dialog-confirm-button"
      (click)="confirm()"
    >
      Confirm
    </button>
  } @else {
    <button
      mat-flat-button
      color="primary"
      class="flex-1"
      data-test-id="select-availability-dialog-refresh-button"
      (click)="reload()"
    >
      Refresh
    </button>
  }
</mat-dialog-actions>
